<template>
    <footer class="footer">
			<div class="footer-main">
				<div class="footer-left">
					<ul v-for="(item,index) in list" :key="index">
						<li class="" v-for="(item1,index1) in item" :key="index1">
							<h5 v-if="index1==0">{{item1.title}}</h5>
							<router-link :to="{name: item1.url}" v-if="index1>0">{{item1.title}}</router-link>
						</li>
					</ul>
				</div>
				<div class="footer-right">
					<h4 class="title">企业合作</h4>
					<div class="mobile">
						<img src="../assets/images/icon_mobile.png" alt="陌陌回收电话">
						<span class="mobile-number">0755-2103-6187</span>
					</div>
					<div class="contact" v-for="(item,index) in contactsList" :key="index">
						<span class="contact-title">{{item.title}}</span>
						<span class="contact-value">{{item.value}}</span>
					</div>
				</div>
			</div>
			<!-- 备案号 -->
			<div class="record-no">
				<span>Copyright Reserved © 2020 深圳市致鑫钰科技有限公司 版权所有</span>
				<a href="https://beian.miit.gov.cn/#/Integrated/index"> 粤ICP备18055303号</a>
			</div>
    </footer>
</template>

<script>
export default {
	data(){
		return {
			list: [
				[
					{title:'交易方式',url:''},
					{title:'快递回收',url:'Express'},
				],
				[
					{title:'质检说明',url:''},
					{title:'质检名词解释',url:'Quality'},
					{title:'回收检测流程',url:'Process'}
				],
				[
					{title:'帮助中心',url:''},
					{title:'常见问题',url:'Problem'},
					{title:'服务条款',url:'Serve'}
				],
				[
					{title:'关于我们',url:''},
					{title:'公司简介',url:'Company'},
				]
			],
			contactsList: [
				{title:'联系人：',value:'李先生'},
				{title:'联系电话：',value:'18820213837'},
				{title:'联系地址：',value:'深圳市龙华新区华荣路163号荣泰大厦1112室'}
			]
		}
	}
}
</script>

<style scoped>
h5{
	margin: 0 0 12px;
}	

ul{
	padding: 0;
	flex: 1;
}

li{
	color: #fff;
	font-size: 20px;
	margin-top: 20px;
}

li:hover a{
	color: #3b9bff;
}

a{
	text-decoration: none;
	color: #9fa3a8;
	font-size: 14px;
}

.footer{
    width: 100%;
    /* height: 220px; */
    background: #333;
}

.footer-main{
	width: 1226px;
	height: 100%;
	margin: 0 auto;
	display: flex;
	padding: 40px 0 30px;
}

.footer-left{
	flex: 4;
	border-right: 1px solid #999;
	display: flex;
	/* align-items: center; */
	margin-right: 80px;
}

.footer-right{
	flex: 2;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.footer-right .title{
	color: #fff;
	font-size: 18px;
	font-weight: normal;
	padding: 0 0 10px;
	margin: 0;
}

.footer-right .mobile{
	display: flex;
	align-items: center;
}

.footer-right .mobile-number{
	color: #f8f8f8;
	font-size: 34px;
	font-weight: bold;
	margin-left: 20px;
}

.footer-right .contact{
	font-size: 14px;
	color: #fff;
	margin-top: 8px;
}

.footer-right .contact .contact-title{
	width: 90px;
	text-align:justify;
	text-align-last:justify;
	display: inline-block;
}

.record-no{
	text-align: center;
	font-size: 18px;
	color: #6d7074;
	border-top: 1px solid #6d7074;
	padding: 10px 0;
}

.record-no a{
	font-size: 18px;
	color: #6d7074;
}
</style>